import { render, staticRenderFns } from "./NavQuestionButtons.vue?vue&type=template&id=7bb167f0&scoped=true"
import script from "./NavQuestionButtons.vue?vue&type=script&lang=js"
export * from "./NavQuestionButtons.vue?vue&type=script&lang=js"
import style0 from "./NavQuestionButtons.vue?vue&type=style&index=0&id=7bb167f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb167f0",
  null
  
)

export default component.exports